<template>
  <div :class="'content' + (lineHeight ? ' content--line-height' : '')">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "M4Content",
  props: {
    lineHeight: Boolean
  }
};
</script>

<style scoped></style>
